var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};


//////////////////
// WEBPACK FOOTER
// /app/~/core-js/library/modules/_cof.js
// module id = ../../../../core-js/library/modules/_cof.js
// module chunks = 7